module.exports = __webpack_public_path__ + "images/adf62acb747615dc80dfda01695a5bf5-north_lake_tahoe.png";